<mat-card class="mb-10 file-manager-box tagus-card" style="height: 45px;
    margin-right: 0px;
    position: relative;
    padding: 5px 5px 5px 5px;">
    <div class="settings-container">
        <router-outlet></router-outlet>
    </div>

</mat-card>